enum AppActionType {
  SET_LOADING = 'SET_LOADING',
  SHOW_MESSAGE = 'SHOW_MESSAGE',
  CLEAR_MESSAGE = 'CLEAR_MESSAGE',
}

export default AppActionType;
